<script>
//import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import simplebar from "simplebar-vue";
import axios from "axios";
/**
 * People-product component
 */
export default {
  page: {
    title: "Add Project",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
    //DatePicker,
  },
  data() {
    return {
      title: "People",
      empLoader: false,
      totalLoader: false,
      totalModal : false,
      onGoingModal: false,
      people: [],
      selctedEmployee: {
        empId: null,
      },
      peopleProjects: [

      ],
      filterValue: null,
    }
  },
  methods: {
    async getAllPeople() {
      this.empLoader = true;
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/people",
          { params: { companyId: this.loginData.companyId } }
        );
        console.log(response.data);
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.people = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.empLoader = false;
    },
    async getAllPeopleProjects() {
      this.totalLoader = true;
      this.peopleProjects = [];
      try {
        const response = await axios.get(process.env.VUE_APP_EMPLOYEE_URL + "/project/people/projects",
          { params: { empId: this.selctedEmployee.empId } }
        );
        console.log(response.data);
        if(response.data.success == "true") {
          if(response.data.data.length > 0) {
            this.peopleProjects = response.data.data;
          }
        }
      } catch (error) {
        //console.log(error);
      }
      this.totalLoader = false;
    },
    openTotalModal(empId) {
      this.selctedEmployee.empId = empId;
      this.totalModal = true;
      this.getAllPeopleProjects();
    },
    openOnGoingModalModal(empId) {
      this.selctedEmployee.empId = empId;
      this.onGoingModal = true;
      this.getAllPeopleProjects();
    },
  },
  created() {
    
    this.loginData = JSON.parse(localStorage.getItem('user'));
    this.getAllPeople();
  },
  computed: {
    searchevents: function(){
      var result = this.people;
      if (!this.filterValue)
        return result;
        
      const filterValue = this.filterValue.toLowerCase();

      const filter = event => 
          event.name.toLowerCase().includes(filterValue) || event.email.toLowerCase().includes(filterValue) || event.designation.toLowerCase().includes(filterValue);
      
      return result.filter(filter);
    },
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="$t('menuitems.projects.list.people')" />
    <div class="row mb-1">
      <div class="col-sm-4">
        <div class="search-box mb-2">
        <div class="position-relative">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('menuitems.projects.search')"
            v-model="filterValue"
          />
          <i class="bx bx-search-alt search-icon"></i>
        </div>
      </div>
      
      </div>
      <div class="col-sm-2"></div>
      <div class="col-sm-6" style="margin-top : -8px;">
          <!--<b-dropdown id="dropdown-dropleft" dropleft text="Drop-Left" variant="outline-secondary" class="m-2" checkbox-menu allow-focus>
            <template #button-content>
              <i class="bx bxs-filter-alt ps-4"></i> <span class="pe-4">Filters</span>
            </template>
            <b-dropdown-form>
              <b-form-checkbox
                  class="form-check mt-2 ms-2"
                >
                  On Time
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Delayed
                </b-form-checkbox>
                <b-form-checkbox
                  class="form-check ms-2"
                >
                  Exceeded Budget
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Remember
                </b-form-checkbox><b-form-checkbox
                  class="form-check ms-2"
                >
                  Remember
                </b-form-checkbox>
              <b-form-checkbox
                  class="form-check ms-2"
                >
                  Remember
                </b-form-checkbox>
            </b-dropdown-form>
        </b-dropdown>-->
      </div>
    </div>
      
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="is-loading">
            <div class="preloader-component" v-show="false">
              <div class="status">
                <div class="spinner-chase">
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                  <div class="chase-dot"></div>
                </div>
              </div>
            </div>
            <div class="card-body" style="height: calc(100vh - 280px)">
            <div class="is-loading">
              <div class="preloader-component" v-show="empLoader">
                <div class="status">
                  <div class="spinner-chase">
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                    <div class="chase-dot"></div>
                  </div>
                </div>
              </div>
                <simplebar style="max-height: calc(100vh - 290px)">
                  <div class="table-responsive">
                    <table
                      class="table align-middle table-nowrap table-hovers"
                    >
                      <thead class="table-light">
                        <tr>
                          <th scope="col">{{ $t('menuitems.projects.details') }}</th>
                          <th scope="col">{{ $t('menuitems.projects.totalProjects') }}</th>
                          <th scope="col">{{ $t('menuitems.projects.workingHours') }}</th>
                          <th scope="col">{{ $t('menuitems.projects.earnings') }}</th>
                          <th scope="col">{{ $t('menuitems.projects.onGoing') }}</th>
                        </tr>
                      </thead>
                      <tbody v-if="searchevents.length > 0">
                          <tr v-for="data in searchevents" :key="data.empId">
                          <td>
                            {{data.name}}<br/>
                            <span class="text-secondary">{{data.email}}</span><br/>
                            <span class="text-secondary">{{data.designation}}</span>
                          </td>
                          <td>
                            <span class="fs-3 me-2">{{data.totalProjects}}</span><span class="badge badge-soft-primary font-size-8" role="button" @click="openTotalModal(data.empId)">view</span>
                          </td>
                          <td>
                            {{data.workingTime}}
                          </td>
                          <td>
                            <span v-if="data.dollarEarnings > 0 && data.rupeeEarnings > 0">$ {{data.dollarEarnings}} & ₹ {{data.rupeeEarnings}} </span>
                            <span v-else-if="data.dollarEarnings > 0">$ {{data.dollarEarnings}}</span>
                            <span v-else-if="data.rupeeEarnings > 0">₹ {{data.rupeeEarnings}}</span>
                            <span v-else>$ 0</span>
                          </td>
                          <td>
                            <span class="fs-3 me-2">{{data.onGoingProjects}}</span><span class="badge badge-soft-primary font-size-8" role="button" @click="openOnGoingModalModal(data.empId)">view</span>
                          </td>
                        </tr>
                      </tbody>
                      <tbody v-else>
                    <div style="margin-top: 50%;margin-left: 135%;">
                      <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180">
                    </div>
                    </tbody>
                    </table>
                  </div>
                </simplebar>
              </div>
            </div>
          </div>
      </div> 
      </div>
    </div>

     <b-modal  v-model="totalModal" size="xl" title="Total Projects" hide-footer>
    <div class="is-loading">
        <div class="preloader-component" v-show="totalLoader">
          <div class="status">
            <div class="spinner-chase">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <div style="height: calc(100vh - 210px)">
        <simplebar ref="current" style="max-height: calc(100vh - 210px);">
          <div class="table-responsive" style="height: calc(100vh - 210px);">
            <table class="table align-middle table-nowrap table-hover" >
              <thead class="table-light">
                <tr>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.projectName') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.dueDate') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.workingHours') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.earnings') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.completionTime') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.status') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.remarks') }}</th>
                </tr>
              </thead>
              
              <tbody v-if="peopleProjects.length > 0">
                  <tr v-for="data in peopleProjects" :key="data.empId">
                  <td>
                    {{data.projectName}}<br/>
                    <span class="text-secondary">{{data.projectDescription}}</span>
                  </td>
                  <td>
                    {{data.deadlineDateTime}}
                  </td>
                  <td>
                    {{data.workingTime}}
                  </td>
                  <td>
                    <span v-if="data.currencyType == 2">₹ </span><span v-else>$ </span>{{data.earnings}}
                  </td>
                  <td>
                    {{data.completionDateTime}}
                  </td>
                  <td>
                    <span v-if="data.status == 2" class="badge badge-soft-success font-size-8">{{ $t('menuitems.projects.completed') }}</span>
                    <span v-else class="badge badge-soft-primary font-size-8">{{ $t('menuitems.projects.onGoing') }}</span>
                  </td>
                  <td>
                    <span v-if="data.remarks == 0" class="text-primary">N.A</span>
                    <span v-if="data.remarks == 1" class="text-primary">{{ $t('menuitems.projects.notStarted') }}</span>
                    <span v-if="data.remarks == 2" class="text-success">{{ $t('menuitems.projects.onTime') }}</span>
                    <span v-if="data.remarks == 3" class="text-warning">{{ $t('menuitems.projects.delayed') }}</span>
                    <span v-if="data.remarks == 4" class="text-success">{{ $t('menuitems.projects.completed') }}</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <div style="margin-top: 50%;margin-left: 135%;">
                  <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180">
                </div>
              </tbody>
            </table>
          </div>
        </simplebar>
        </div>
    </div>
    </b-modal>

    <b-modal v-model="onGoingModal" size="xl" centered :title="$t('menuitems.projects.onGoing')" hide-footer>
    <div class="is-loading">
      <div class="preloader-component" v-show="totalLoader">
        <div class="status">
          <div class="spinner-chase">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <div style="height: calc(100vh - 210px)">
        <simplebar ref="current" style="max-height: calc(100vh - 210px);">
          <div class="table-responsive" style="height: calc(100vh - 210px);">
            <table class="table align-middle table-nowrap table-hover" >
              <thead class="table-light">
                <tr>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.projectName') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.dueDate') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.workingHours') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.earnings') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.totalProgress') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.individualProgress') }}</th>
                  <th scope="col" >{{ $t('menuitems.projects.peopleProjectsModal.remarks') }}</th>
                </tr>
              </thead>
              <tbody v-if="peopleProjects.length > 0">
                  <tr v-for="data in peopleProjects" :key="data.empId" >
                  <td v-if="data.status != 2">
                    {{data.projectName}}<br/>
                    <span class="text-secondary">{{data.projectDescription}}</span>
                  </td>
                  <td v-if="data.status != 2">
                    {{data.deadlineDateTime}}
                  </td>
                  <td v-if="data.status != 2">
                    {{data.workingTime}}
                  </td>
                  <td v-if="data.status != 2">
                    <span v-if="data.currencyType == 2">₹ </span><span v-else>$ </span>{{data.earnings}}
                  </td>
                  <td v-if="data.status != 2">
                    {{data.totalProgress}} %
                  </td>
                  <td v-if="data.status != 2">
                    {{data.individualProgress}} %
                  </td>
                  <td v-if="data.status != 2">
                    <span v-if="data.remarks == 0" class="text-primary">N.A</span>
                    <span v-if="data.remarks == 1" class="text-primary">{{ $t('menuitems.projects.notStarted') }}</span>
                    <span v-if="data.remarks == 2" class="text-success">{{ $t('menuitems.projects.onTime') }}</span>
                    <span v-if="data.remarks == 3" class="text-warning">{{ $t('menuitems.projects.delayed') }}</span>
                    <span v-if="data.remarks == 4" class="text-success">{{ $t('menuitems.projects.completed') }}</span>
                  </td>
                </tr>
              </tbody>
              <tbody v-else>
                <div style="margin-top: 50%;margin-left: 135%;">
                  <img src="@/assets/images/no-data.png" alt="No Data"  height="180" width="180">
                </div>
              </tbody>
            </table>
          </div>
          </simplebar>
      </div>
    </div>
    </b-modal>
  </Layout>
</template>
<style scoped>
.is-loading {
  position: relative;
}
.preloader-component {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #fff;
  z-index: 999;
  width: 100%;
}
.status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px;
}
</style>